import { api } from "@/lib/api";

// Workspace client — small helper for endpoints exposed by routes/workspaces.py.
// Currently only the "start a trial from an existing logged-in account" call is
// exposed here; add more helpers as needed.
export const workspaceApi = {
  // Provisions a workspace + 14-day trial for the currently logged-in user.
  // Primary caller: PartnerDashboard "Start a trial" CTA for partner-only users
  // who don't yet have a workspace. Returns the full auth-payload shape so the
  // frontend can hydrate AuthContext directly from the response if it wants —
  // most callers just call refreshSession() after success.
  startTrial: (payload = {}) => api.post("/workspaces/start-trial", payload).then((r) => r.data),
};
